import { isTestFlow } from "@/core/flow/test-flow-id";

/** `testFlow` comes from `isTestFlowEnabled()` or `useRuntimeConfig()`. */
export const isDevConsoleEnabled = (
	flowId?: string,
	testFlow = false
): boolean =>
	process.env.NODE_ENV === "development" || isTestFlow(flowId, testFlow);
